// src/utils/dateUtils.ts
export const holidays = [
    '2025-01-01', // New Year's Day
    //'2025-01-20', // Martin Luther King Jr. Day (3rd Monday in January)
    //'2025-02-17', // Presidents' Day (3rd Monday in February)
    '2025-05-26', // Memorial Day (Last Monday in May)
    '2025-07-04', // Independence Day
    '2025-09-01', // Labor Day (1st Monday in September)
    '2025-11-27', // Thanksgiving (4th Thursday in November)
    '2025-11-28', // Day after Thanksgiving
    '2025-12-25', // Christmas Day
];

// Helper to format date to YYYY-MM-DD
const formatDateToString = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

// Helper to parse Salesforce date safely
const parseSalesforceDate = (dateString: string): Date => {
    try {
        // First try direct parsing
        const date = new Date(dateString);
        
        // Validate the date is valid
        if (isNaN(date.getTime())) {
            throw new Error('Invalid date');
        }
        
        return date;
    } catch (error) {
        console.error('Error parsing date:', dateString, error);
        // Fallback: try parsing the date portion only
        const [datePart] = dateString.split('T');
        const [year, month, day] = datePart.split('-').map(Number);
        return new Date(year, month - 1, day);
    }
};

export const getNextBusinessDays = (createdDate: string, numberOfDays: number = 5): Date[] => {
    console.log('Input created date:', createdDate);
    
    try {
        const startDate = parseSalesforceDate(createdDate);
        console.log('Parsed start date:', startDate);
        
        const businessDays: Date[] = [];
        const currentDate = new Date(startDate);
        currentDate.setDate(currentDate.getDate() + 1); // Start from next day

        while (businessDays.length < numberOfDays) {
            const dateToCheck = new Date(currentDate);
            
            if (!isWeekend(dateToCheck) && !isHoliday(dateToCheck)) {
                // Create a clean date object for just the date portion
                const cleanDate = new Date(
                    dateToCheck.getFullYear(),
                    dateToCheck.getMonth(),
                    dateToCheck.getDate(),
                    12, // Set to noon to avoid timezone issues
                    0,
                    0,
                    0
                );
                businessDays.push(cleanDate);
            }
            
            currentDate.setDate(currentDate.getDate() + 1);
        }

        return businessDays;
    } catch (error) {
        console.error('Error generating business days:', error);
        throw error;
    }
};

export const isHoliday = (date: Date): boolean => {
    const dateString = formatDateToString(date);
    return holidays.includes(dateString);
};

export const isWeekend = (date: Date): boolean => {
    const day = date.getDay();
    return day === 0 || day === 6; // 0 is Sunday, 6 is Saturday
};